// ##### 24-09-09 Komarov
import moment from 'moment';
// ##### Komarov 2025-07-23
import React, { useEffect } from 'react';
// ##### 23-09-14 Komarov
// import './SearchItems.css'
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import DivTag from './DivTag';
// ##### 25-05-10 Komarov
import { useSelector } from 'react-redux';
// ##### Komarov 2025-08-26
import { setTimeMark } from '../../../../../utils/timeUtils';

let effectNumber = 0;
const componentName = 'ItemObj';

// ##### Komarov 2025-07-13
const ItemObj = ({ tariff, tour_name, pickedCurrency }) => {
  // ##### Komarov 2025-07-14
  const language = useSelector(state => state.language);
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  componentDevMode && useEffect(() => {
    moment.locale(language);
    componentDevMode && setTimeMark(`l:24 ${componentName} effect ${++effectNumber} end:`, componentDevMode);
  }, [language]);
  // ##### 23-03-01 Komarov
  return (
    <>
      {/* ##### 23-11-02 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <DivTag
          className="div_TourItemObj"
          tariff={tariff}
          tour_name={tour_name}
          pickedCurrency={pickedCurrency}
        />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <DivTag
          className="div_TourItemObjSmallScreen"
          tariff={tariff}
          tour_name={tour_name}
          pickedCurrency={pickedCurrency} />
      </Media>
    </>
  );
};

export default ItemObj;
